import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/no-unused-prop-types */
import { useCallback } from 'react';
import { useScaleChecked } from '../../context/ScaleContext';
function TreeNodes({ nodesData, levelHeight, startY, signalID, labelOptions, showLabels, }) {
    const { scaleX } = useScaleChecked();
    const buildTreeNodeAndEdge = useCallback(({ startX, _startX, ratio, multiplicityIndex, color }) => {
        const edgeLevel = 2 * multiplicityIndex + 2;
        const _startYEdge = startY + edgeLevel * levelHeight;
        const _startYNode = startY + (edgeLevel + 1) * levelHeight;
        return (_jsxs("g", { children: [_jsx("text", { textAnchor: "middle", x: scaleX()(_startX) + labelOptions.distance, y: _startYNode + 2 * (levelHeight / 3), fontSize: labelOptions.fontSize, fill: color, visibility: showLabels ? 'visible' : 'hidden', children: ratio }), _jsx("line", { x1: scaleX()(startX), y1: _startYEdge, x2: scaleX()(_startX), y2: _startYNode, stroke: color }), _jsx("line", { x1: scaleX()(_startX), y1: _startYNode, x2: scaleX()(_startX), y2: _startYNode + levelHeight, stroke: color })] }, `${multiplicityIndex}_${signalID}_${startX}_${_startX}_${ratio}`));
    }, [
        signalID,
        labelOptions.distance,
        labelOptions.fontSize,
        scaleX,
        showLabels,
        startY,
        levelHeight,
    ]);
    return _jsx(_Fragment, { children: nodesData?.map((node) => buildTreeNodeAndEdge(node)) });
}
export default TreeNodes;
